// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"03a8a50f","303":"c427b8e1","639":"5572ba1f","641":"45005753","685":"60fd3307","688":"d216abbd","713":"74d19b54","726":"d8218b6f","850":"87a66040","967":"da6fd3fc"}[chunkId] + ".chunk.js";
};